import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTenantInMarketStore } from '../..';
import useInsightsShape from '../../hooks/useInsightsShape';
import useTenantsInMarketInsideShape from '../../hooks/useTenantsInMarketInsideShape';
import { IDetailsTabProps } from '../../interfaces/IDetailsTabProps';
import useTenantsInMarketWithGlobalFilters from '../../interfaces/useTenantsInMarketWithGlobalFilters';
import TenantsInMarketGrid from '../tenantsInMarket/TenantsInMarketGrid';

function InsightsTenantsInMarketTab({ visible, setEntityCount }: IDetailsTabProps) {
    const tenantsInMarketStore = useTenantInMarketStore();
    const insightsShape = useInsightsShape();
    const tenantsInMarket = useTenantsInMarketWithGlobalFilters(useTenantsInMarketInsideShape(tenantsInMarketStore.tenantsInMarket, insightsShape));

    useEffect(() => setEntityCount(tenantsInMarket.length), [tenantsInMarket]);

    if (!visible || !insightsShape)
        return null;

    return (
        <TenantsInMarketGrid tenantsInMarket={tenantsInMarket} />
    );
}

export default observer(InsightsTenantsInMarketTab);